export default __webpack_public_path__ + "static/media/info_1.b019d780.jpeg";